// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"28550c24","259":"e9451f95"}[chunkId] + ".chunk.js";
};